var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68956 0.571777L0.370117 7.89122V18.2523L7.68956 25.5718H18.0507C20.509 23.1273 25.3701 18.2523 25.3701 18.2523V7.89122L18.0507 0.571777M8.84234 3.34956H16.8979L22.5923 9.044V17.0996L16.8979 22.794H8.84234L3.14789 17.0996V9.044M11.4812 17.2384H14.259V20.0162H11.4812V17.2384ZM11.4812 6.12733H14.259V14.4607H11.4812V6.12733Z",
    fill: "#E70404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.52157093341ee40a0bd6b1f703477153.svg";
export { ForwardRef as ReactComponent };